import { Controller } from "@hotwired/stimulus"
import { debug } from "../debug"

// This is a placeholder controller that is not currently used.
// Navigation functionality is implemented with vanilla JavaScript in application.html.erb.
// This controller is kept for reference and possible future use.
//
// See /app/views/layouts/application.html.erb for the active implementation.
// See /docs/TURBO_INTEGRATION.md for details on how navigation works with Turbo.

export default class extends Controller {
  connect() {
    debug("Nav controller connected - not actively used");
  }
}
